import { DataSourceMode, DataSourceExecutionEvent, DataSourceAction, ChangeEvent } from "@mcleod/components";
import { AutogenLayoutEmptyStop } from "./autogen/AutogenLayoutEmptyStop";

enum Position {
    PREV = "PREV",
    AFTER = "AFTER",
}

export class EmptyStop extends AutogenLayoutEmptyStop {
    private emptyPosition: string;

    onLoad(): void {
        this.sourceStop.mode = DataSourceMode.ADD;
    }


    /** This is an event handler for the beforeExecution event of sourceEmptyStop. */
    sourceEmptyStopBeforeExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.ADD) {
            this.activeRow.set("stop_data", this.sourceStop.activeRow.data);
            this.activeRow.set("position", this.emptyPosition);
            this.activeRow.set("equipment_id", this.activeRow.get("equipment_row_id"));
        }
    }
}
